import { createSlice } from "@reduxjs/toolkit";
import { getProducts } from "./shop";

const initialState = {
    isLoading: false,
}

const listActions=[
    getProducts
]


export const loaderSlice = createSlice({
    name:"loader",
    initialState,
    reducers:{
        showLoader:(state)=>{
            state.isLoading=true;
        },
        hideLoader:(state)=>{
            state.isLoading=false;
        },
    },
    extraReducers: (builder) => {
        listActions.forEach((action) => {
        builder
            .addCase(action.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(action.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(action.rejected, (state, action) => {
                state.isLoading = false;
            })
        });
    }
})

export const {showLoader,hideLoader} =loaderSlice.actions;
export default loaderSlice.reducer;